import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutGrid, PackagePlus, ScanLine, Boxes, Scale, Truck, LogOut, Tags, Printer, TrendingUp } from "lucide-react";

const NAV = [
  { to: "/wms", label: "Dashboard", icon: LayoutGrid, end: true },
  { to: "/wms/carichi", label: "Carichi", icon: PackagePlus },
  { to: "/wms/scan", label: "Scansiona", icon: ScanLine },
  { to: "/wms/giacenze", label: "Giacenze", icon: Boxes },
  { to: "/wms/bilancio", label: "Bilancio", icon: Scale },
  { to: "/wms/prezzi", label: "Prezzi", icon: TrendingUp },
  { to: "/wms/articoli", label: "Articoli", icon: Tags },
  { to: "/wms/fornitori", label: "Fornitori", icon: Truck },
  { to: "/wms/stazione", label: "Stazione", icon: Printer },
];

export default function WmsLayout({ user, onLogout, children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F5F5F4] font-['IBM_Plex_Sans']">
      <header className="bg-zinc-950 text-white sticky top-0 z-40">
        <div className="max-w-[1600px] mx-auto px-3 md:px-6">
          <div className="flex items-center justify-between h-16">
            <button onClick={() => navigate("/wms")} className="flex items-baseline gap-2" data-testid="wms-brand">
              <span className="font-['Chivo'] font-black text-2xl tracking-tighter">i<span className="text-[#FF4500]">TRACE</span></span>
              <span className="hidden sm:inline text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-400">WMS/MES</span>
            </button>
            <div className="flex items-center gap-3">
              <span className="hidden md:inline text-sm text-zinc-400">{user?.name || user?.email}</span>
              <button onClick={onLogout} className="h-12 px-4 flex items-center gap-2 text-sm font-bold uppercase text-zinc-300 hover:bg-zinc-800 border border-zinc-700" data-testid="wms-logout">
                <LogOut className="w-4 h-4" /> Esci
              </button>
            </div>
          </div>
          <nav className="flex overflow-x-auto -mx-1 pb-0">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`wms-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 md:px-5 h-14 font-bold uppercase text-xs md:text-sm whitespace-nowrap border-b-4 transition-colors ${
                    isActive ? "border-[#FF4500] text-white bg-zinc-900" : "border-transparent text-zinc-400 hover:text-white"
                  }`
                }
              >
                <n.icon className="w-5 h-5" /> {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-3 md:px-6 py-5 md:py-8">{children}</main>
    </div>
  );
}
